import { useDebounce } from 'common';

// Warning threshold for prompt length. Based on https://help.openai.com/en/articles/4936856-what-are-tokens-and-how-to-count-them.
const TOKEN_WARNING_THRESHOLD = 3500;

interface UseTokenWarningProps {
  promptValue: string;
}

export function useTokenWarning(props: UseTokenWarningProps) {
  const { promptValue } = props;
  const debouncedPromptValue = useDebounce(promptValue, 300);
  const tokenCount = Math.ceil(debouncedPromptValue.length / 4);
  return {
    tokenCountIsAboveThreshold: tokenCount > TOKEN_WARNING_THRESHOLD,
    tokenCount,
    threshold: TOKEN_WARNING_THRESHOLD,
  };
}
